/**
 * @generated SignedSource<<78ddf47d5a07bc96a5ddabf9da577b7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavItems_links$data = {
  readonly navItems: ReadonlyArray<{
    readonly dataTn: string | null;
    readonly eventName: string | null;
    readonly href: string | null;
    readonly interactionType: string | null;
    readonly items?: ReadonlyArray<{
      readonly href: string | null;
      readonly title: string | null;
    } | null> | null;
    readonly newWindow: boolean | null;
    readonly title: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"NavExpandingAreaItems_navItem" | "NavItem_navItem">;
  } | null> | null;
  readonly " $fragmentType": "NavItems_links";
};
export type NavItems_links$key = {
  readonly " $data"?: NavItems_links$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavItems_links">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "href",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavItems_links",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "navItems",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NavItem_navItem"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NavExpandingAreaItems_navItem"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NavBarListItem",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "NavBarList",
          "abstractKey": null
        },
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dataTn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newWindow",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "interactionType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NavBarLinks",
  "abstractKey": null
};
})();

(node as any).hash = "f066f074090d53b4f2e697bfb23e0250";

export default node;
